import React, { useEffect } from 'react';

const Home: React.FC = () => (
  <div />
);

export default Home;
